import React from 'react';
import { Box, Grid } from '@material-ui/core';

import { HeaderPropsType } from 'containers/SignupPages/types';
import {
  StyledLargeSectionHeader,
  StyledShortBody,
} from 'containers/SignupPages/Header/styles';

const Header = ({ title, subTitle, icon }: HeaderPropsType) => (
  <Box paddingY={2} paddingX={[2, 8, 12]}>
    <Grid container direction="row" alignItems="flex-end">
      <StyledLargeSectionHeader weight="500">{title}</StyledLargeSectionHeader>
      {icon && (
        <Box paddingBottom={1.75} marginLeft={2}>
          <img width="44" height="40" src={icon} alt="notFoundIcon" />
        </Box>
      )}
    </Grid>
    <StyledShortBody weight="400">{subTitle}</StyledShortBody>
  </Box>
);

export default Header;
